import { userInfoSafe } from 'hub-http/userInfo';
export const VISIBILITY_GRACE_MS = 30000;
export const VISIBILITY_GATE = 'Pulse:VisibilityHandling';
let __TEST_ONLY_DISABLED = false;
let gateCheck;
export const __testOnlyDisableVisibilityHandling = () => {
  __TEST_ONLY_DISABLED = true;
};
export const __testOnlyEnableVisibilityHandling = () => {
  __TEST_ONLY_DISABLED = false;
  gateCheck = undefined;
};
const isGateEnabled = () => {
  var _gateCheck;
  (_gateCheck = gateCheck) !== null && _gateCheck !== void 0 ? _gateCheck : gateCheck = userInfoSafe().then(({
    gates
  }) => gates.includes(VISIBILITY_GATE), () => false);
  return gateCheck;
};
export const createVisibilityManager = ({
  logger,
  getAttachedKeys,
  isSettled,
  hasData,
  isExpired,
  isDefinitionKeptAlive,
  refresh,
  suspend,
  resume
}) => {
  let hidden = false;
  let graceTimer;
  const queued = new Map();
  const keepAliveCounts = new Map();
  const isKeptAlive = instanceKey => keepAliveCounts.has(instanceKey) || isDefinitionKeptAlive(instanceKey);
  const suspendAll = () => {
    for (const instanceKey of getAttachedKeys()) {
      if (!isKeptAlive(instanceKey) && isSettled(instanceKey)) {
        suspend(instanceKey);
      }
    }
    logger === null || logger === void 0 || logger.debug('suspended resolvers');
  };
  const onHidden = () => {
    hidden = true;
    graceTimer = setTimeout(suspendAll, VISIBILITY_GRACE_MS);
    logger === null || logger === void 0 || logger.debug('page hidden');
  };
  const onVisible = () => {
    hidden = false;
    clearTimeout(graceTimer);
    const toRefresh = new Map(queued);
    queued.clear();
    for (const instanceKey of getAttachedKeys()) {
      resume(instanceKey);
      if (!toRefresh.has(instanceKey) && isExpired(instanceKey)) {
        toRefresh.set(instanceKey, undefined);
      }
    }
    logger === null || logger === void 0 || logger.debug('page visible', {
      refreshing: toRefresh.size
    });
    for (const [instanceKey, changeContext] of toRefresh) {
      refresh(instanceKey, changeContext);
    }
  };
  const onVisibilityChange = () => {
    if (document.visibilityState !== 'hidden') {
      if (hidden) {
        onVisible();
      }
      return;
    }
    if (__TEST_ONLY_DISABLED || hidden) {
      return;
    }
    void isGateEnabled().then(gateEnabled => {
      if (gateEnabled && document.visibilityState === 'hidden' && !hidden) {
        onHidden();
      }
    });
  };
  document.addEventListener('visibilitychange', onVisibilityChange);
  return {
    requestRefresh: (instanceKey, changeContext) => {
      if (hidden && !isKeptAlive(instanceKey) && hasData(instanceKey)) {
        logger === null || logger === void 0 || logger.debug('queueing refresh while hidden', {
          instanceKey
        });
        queued.set(instanceKey, changeContext);
        return;
      }
      refresh(instanceKey, changeContext);
    },
    keepAlive: instanceKey => {
      var _keepAliveCounts$get;
      keepAliveCounts.set(instanceKey, ((_keepAliveCounts$get = keepAliveCounts.get(instanceKey)) !== null && _keepAliveCounts$get !== void 0 ? _keepAliveCounts$get : 0) + 1);
      resume(instanceKey);
      if (queued.has(instanceKey)) {
        refresh(instanceKey, queued.get(instanceKey));
        queued.delete(instanceKey);
      }
      return () => {
        const remaining = keepAliveCounts.get(instanceKey) - 1;
        if (remaining > 0) {
          keepAliveCounts.set(instanceKey, remaining);
        } else {
          keepAliveCounts.delete(instanceKey);
        }
      };
    },
    destroy: () => {
      clearTimeout(graceTimer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    }
  };
};